import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";

import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import DropzoneForContact from "../Contacts/DropzoneForContact";
import Images from "../../Images";
import { toast } from "react-toastify";
import DropZone from "./Dropzone";
import { useTranslation } from "react-i18next";


const LostCertificateModal = ({
  setOpenLostCertificateModel, postLostCertificateMutate, selectedItem, uploadLostCertificateLoading
}) => {
  
  const [certificate, setCertificate] = useState("");
  const serviceType=""
  const user = useSelector((state) => state?.UserReducer?.user);
  const [associationName, setAssocNameLabel] = useState("");
  const { t, i18n } = useTranslation();

  const InitialValues = {
    customerId: user.id,
    email: user.email,
    userType: user.userType,
    assocId: selectedItem.id,
    assocName: selectedItem.assocName,
    serviceType: 5,
    remarks:'',
    // assocName: associationName,
    // id: selectedItem?.id,
    // serviceType: serviceType,
    // status: selectedItem?.status,
    certificate: "",
  };


  console.log("user", user);
  console.log("selectedItem", selectedItem);


  const SubmitHandler = (values) => {
    if (certificate == '')
      return toast.error("Please upload document");
      //postUploadCancel({ fileName: certificate, appId: selectedItem?.id, });
      //values.append("fileName", certificate);
      postLostCertificateMutate({ fileName: certificate, assocId: selectedItem?.id,
         assocName: selectedItem.assocName, customerId: user.id,
         email: user.email,
         userType: user.userType,
         serviceType: 5,
         remarks : values.remarks,
        });
  };

  const SingleCard = ({ title, bg, icon, link }) => {
    return (
        <SingleCardWrapper $bg={bg}>
          {/* {icon} */}
          <p className="text-sm sm:text-base">{title}</p>
        </SingleCardWrapper>
    
    );
  };

  return (
    <Model width={`w-11/12 max-w-xl `} setOpenModel={setOpenLostCertificateModel}>
      <Title>{t("LostCertificateRequest")}</Title>
      {uploadLostCertificateLoading && <Loading />}

      {!uploadLostCertificateLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
            <InputGroup>
                <Label htmlFor="remarks">{t("Remarks")}</Label>
                <FieldWrapper>
                  <Field
                     name="remarks"
                     type="textarea"
                     id="remarks"
                     autoComplete="off"
                     component="textarea" 
                     rows="2"
                     required
                  />
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                    <Label htmlFor="certificate">
                      {t("UploadLostDocumentReport")}
                    </Label>
                    <DropZone setUploadFile={setCertificate} required/>
              </InputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit" disabled={!certificate}>{t("Upload")}</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;
const SingleCardWrapper = tw.div`
${(p) => p.$bg}
p-4  h-22 w-22 rounded-lg  shadow-lg border border-gray-100 cursor-pointer  transition duration-200 flex flex-col justify-center space-y-5 items-center  hover:scale-95 transform hover:shadow-sm text-center`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center`;

export default LostCertificateModal;
